import type { AppRoute } from 'src/routes/types';

import { Folder } from '@mui/icons-material';
import { t } from 'i18next';
import { lazy } from 'react';

const CompanyVaultView = lazy(() => import('./views/CompanyVaultView.tsx'));
const CompanyVaultDocumentEditor = lazy(
  () => import('./views/CompanyVaultDocumentEditor.tsx')
);

const vaultRoutePaths = {
  companyVaultDocumentEditor: '/organization/vault/editor/:fileId',
  companyVaultFolder: '/organization/vault/folder/:folderId',
  companyVaultRoot: '/organization/vault',
} as const;

const vaultRoutes: AppRoute[] = [
  {
    element: <CompanyVaultView />,
    enabled: true,
    menu: {
      group: 'management',
      icon: <Folder />,
      title: () => t('organization:COMPANY_DOCUMENTS'),
    },
    path: vaultRoutePaths.companyVaultRoot,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <CompanyVaultView />,
    enabled: true,
    path: vaultRoutePaths.companyVaultFolder,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <CompanyVaultDocumentEditor />,
    enabled: true,
    path: vaultRoutePaths.companyVaultDocumentEditor,
    permission: 'all',
    scope: 'private',
  },
];

export const organizationRoutePaths = {
  ...vaultRoutePaths,
};

export const organizationRoutes: AppRoute[] = [...vaultRoutes];
